.card {
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  background: var(--surface);
  padding: var(--space-5);
}

.elevated {
  background: var(--surface-elevated);
  box-shadow: var(--shadow-card);
}

/* Reserved for the surface that must win attention on a board — the leading placement. */
.lead {
  background: var(--surface-elevated);
  border-color: var(--brass-rule);
  box-shadow: var(--shadow-elevated);
}
